export interface ErrorWithMessage {
  message: string
}

export const errorHasMessage = (error: unknown): error is ErrorWithMessage => {
  return (error as ErrorWithMessage).message !== undefined && typeof (error as ErrorWithMessage).message === 'string'
}

export interface ErrorWithCode {
  code: string
}

export const errorHasCode = (error: unknown): error is ErrorWithCode => {
  return (error as ErrorWithCode).code !== undefined && typeof (error as ErrorWithCode).code === 'string'
}
